<template>
    <svg :width="width" height="18" viewBox="0 0 52 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M26.8931 5.93855C26.8635 8.27774 28.9778 9.58302 30.5705 10.3592C32.2069 11.1554 32.7565 11.6661 32.75 12.3782C32.7379 13.468 31.4448 13.949 30.2348 13.9677C28.1237 14.0004 26.8962 13.3977 25.9204 12.9419L25.1599 16.5004C26.1389 16.9516 27.9518 17.345 29.8317 17.3623C34.2446 17.3623 37.1317 15.184 37.1473 11.8066C37.1646 7.52029 31.2185 7.28304 31.2591 5.36716C31.2731 4.78623 31.8275 4.16629 33.0421 4.00867C33.6434 3.92904 35.3031 3.8681 37.1849 4.73463L37.9234 1.29166C36.9115 0.923197 35.6109 0.570368 33.9915 0.570368C29.838 0.570368 26.9167 2.77834 26.8931 5.93855ZM45.0202 0.86693C44.2144 0.86693 43.5354 1.33696 43.2323 2.05826L36.9287 17.1094H41.3384L42.2159 14.6843H47.6044L48.1134 17.1094H52L48.6084 0.86693H45.0202ZM45.6371 5.25463L46.9097 11.3539H43.4245L45.6371 5.25463ZM21.5467 0.867132L18.0708 17.1092H22.2729L25.7471 0.866726H21.5467V0.867132ZM15.3305 0.866726L10.9568 11.9222L9.18755 2.5222C8.97995 1.47285 8.16014 0.86693 7.24973 0.86693H0.100141L0 1.33858C1.46778 1.65709 3.13544 2.17079 4.14578 2.72045C4.76409 3.05621 4.94041 3.34973 5.14353 4.1476L8.49448 17.1094H12.935L19.7429 0.86693H15.3305" fill="url(#paint0_linear_1862_23728)"/>
        <defs>
        <linearGradient id="paint0_linear_1862_23728" x1="23.9065" y1="17.6992" x2="24.3925" y2="0.453586" gradientUnits="userSpaceOnUse">
        <stop stop-color="#222357"/>
        <stop offset="1" stop-color="#254AA5"/>
        </linearGradient>
        </defs>
        </svg>
        
</template>

<script>
    export default {
       props: ['width'] 
    }
</script>

<style lang="scss" scoped>

</style>